import { makeStyles } from '@material-ui/core/styles';

import { COLORS, FONTS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      padding: theme.spacing(2),
      backgroundColor: COLORS.neutral.darkGray,
      color: COLORS.gray.white,
      borderRadius: theme.shape.borderRadius,
      display: 'flex',
      flexDirection: 'column',
    },
    title: {
      fontSize: theme.typography.pxToRem(18),
      fontFamily: FONTS.DMSans,
      marginBottom: theme.spacing(1.5),
    },
    usageTitles: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: theme.spacing(0.5),
    },
    usageTitle: {},
    usageTitleLimited: {
      color: COLORS.error.active,
    },
    linearProgress: {
      backgroundColor: COLORS.neutral.mediumGray,
      height: 6,
    },
    bar: {
      backgroundColor: COLORS.gray.white,
    },
    limitBar: {
      backgroundColor: COLORS.error.active,
    },
    halfLimitBar: {
      backgroundColor: COLORS.warning.default,
    },
    limited: {},
    description: {
      margin: theme.spacing(1.5, 0),
      color: COLORS.neutral.lightGray,
    },
    button: {
      backgroundColor: COLORS.gray.white,
      color: COLORS.primary.default,
    },
  }),
  { name: 'TrialProgress' }
);
